import React from 'react';
import { Link } from 'react-router-dom';
import { createSelector } from 'reselect';
import CustomTooltip from '../../../Tooltip';
import { I18nFormatter } from 'utils/I18n/I18n';
import UserStore from '../../../../stores/UserStore';
import { getStatus } from '../../../../helpers/common';
// getPath not used after builder adoption
import { buildUiUrl } from '../../../../helpers/urlBuilder';
import { getPaymentMethod, getPaymentSystem } from '../../../../helpers/common';

const payouts = (state) => state.publisherPayouts.list;

export const getHeaderNames = createSelector(
    () => {
        const tableNames = UserStore.getTranslation().dataTable.headers;

        return [
            tableNames.id,
            tableNames.createdAt,
            tableNames.status,
            tableNames.comment,
            tableNames.writingDownSum,
            tableNames.payoutSum,
            tableNames.commission,
            tableNames.system,
            tableNames.currency,
            tableNames.account,
            tableNames.note,
            tableNames.actions
        ];
    }
);

export const getPayouts = createSelector(
    payouts,
    (payouts = []) => {
        const payoutNames = UserStore.getTranslation().payoutPage;
        const staticNamesAction = UserStore.getTranslation().actions;
        let list = [];

        payouts.forEach((item, i) => {
            const paymentMethod = getPaymentMethod(item.payment_method_details.payment_method);
            const paymentSystem = getPaymentSystem(paymentMethod.payment_system);
            const paymentPath = buildUiUrl('payoutItem', { id: item.id });
            let noteMobile = '<div class="wrap__mobile"><div class="row-title">' + payoutNames.note + '</div>' +
                '<div class="accountInfo__container row-value">' + payoutNames.affiliatePayout + '<br/>'
                + I18nFormatter.fullDateTime(+item.from_dt) + ' - ' + I18nFormatter.fullDateTime(+item.created_at)
                + '</div></div>';

            list.push({
                id: (
                    <div>
                        <span className="wrap__desktop">{item.id}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{payoutNames.id}</div>
                            <div className="row-value">{item.id}</div>
                        </div>
                    </div>
                ),
                createdAt: (
                    <div>
                        <span className="wrap__desktop">{I18nFormatter.fullDateTime(+item.created_at)}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{payoutNames.createdAt}</div>
                            <div className="row-value">{I18nFormatter.fullDateTime(+item.created_at)}</div>
                        </div>
                    </div>
                ),
                status: (
                    <div>
                        <span className="wrap__desktop">{getStatus(item.status)}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{payoutNames.status}</div>
                            <div className="row-value">{getStatus(item.status)}</div>
                        </div>
                    </div>
                ),
                comment:  (
                    <div>
                        <span className="wrap__desktop">{item.comment}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{payoutNames.comment}</div>
                            <div className="row-value">{item.comment}</div>
                        </div>
                    </div>
                ),
                sumOriginal: (
                    <div>
                        <span className="wrap__desktop">{I18nFormatter.currency(item.sum_original.amount, item.sum_original.currency, true)}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{payoutNames.originalSum}</div>
                            <div className="row-value">{I18nFormatter.currency(item.sum_original.amount, item.sum_original.currency, true)}</div>
                        </div>
                    </div>
                ),
                sum: (
                    <div>
                        <span className="wrap__desktop">{I18nFormatter.currency(item.sum.amount, item.sum.currency, true)}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{payoutNames.sum}</div>
                            <div className="row-value">{I18nFormatter.currency(item.sum.amount, item.sum.currency, true)}</div>
                        </div>
                    </div>
                ),
                commission: (
                    <div>
                        <span className="wrap__desktop">{I18nFormatter.currency(item.fee.amount, item.fee.currency, true)}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{payoutNames.commission}</div>
                            <div className="row-value">{I18nFormatter.currency(item.fee.amount, item.fee.currency, true)}</div>
                        </div>
                    </div>
                ),
                paymentSystem: (
                    <div>
                        <span className="wrap__desktop">{paymentSystem.title || ''}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{payoutNames.paymentSystemTitle}</div>
                            <div className="row-value">{paymentSystem.title || ''}</div>
                        </div>
                    </div>
                ),
                currency: (
                    <div>
                        <span className="wrap__desktop">{paymentMethod.currency || ''}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{payoutNames.currency}</div>
                            <div className="row-value">{paymentMethod.currency || ''}</div>
                        </div>
                    </div>
                ),
                number: (
                    <div>
                        <span className="wrap__desktop">{item.payment_method_details.number}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{payoutNames.accountNumber}</div>
                            <div className="row-value">{item.payment_method_details.number}</div>
                        </div>
                    </div>
                ),
                note: '<div class="wrap__desktop">'
                    + `${payoutNames.affiliatePayout}<br/>${I18nFormatter.fullDateTime(+item.from_dt)} &mdash;${I18nFormatter.fullDateTime(+item.created_at)}`
                    + '</div>',
                noteMobile: noteMobile,
                actions: (
                    <div>
                        <div className="wrap__desktop">
                            <div className="row-controls">
                                <CustomTooltip id={`more-info-${i}`} tooltip={staticNamesAction.view}>
                                    <Link className="control-item" to={paymentPath}>
                                        <span className="fa fa-eye" />
                                    </Link>
                                </CustomTooltip>
                            </div>
                        </div>
                        <div className="wrap__mobile">
                            <div className="row-value">
                                <Link className="control-item" to={paymentPath}>
                                    <span className="details_link">{staticNamesAction.view}</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                )
            });
        });

        return list;
    }
);
